import script from "./inclus.vue?vue&type=script&setup=true&lang=ts"
export * from "./inclus.vue?vue&type=script&setup=true&lang=ts"

import "./inclus.vue?vue&type=style&index=0&id=68574466&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68574466"]])

export default __exports__